// extracted by mini-css-extract-plugin
module.exports = {"slider_col":"styles_slider_col__3xqCI"};